import React from "react";
import { Box, Text } from "grommet";
import { useAuth } from "../context";

// Gates a route behind Cognito group membership. Mirrors the backend's
// require_group() dependency - this is a UX convenience only, the backend
// is the real enforcement point.
const RequireGroup = ({ group, children }) => {
    const { isAuthenticated, isLoading, login, isInGroup } = useAuth();

    if (isLoading) {
        return null;
    }

    if (!isAuthenticated) {
        login();
        return null;
    }

    if (!isInGroup(group)) {
        return (
            <Box align="center" justify="center" pad="large" fill>
                <Text size="large" weight="bold">
                    Access restricted
                </Text>
                <Text margin={{ top: "small" }}>
                    You need to be in the '{group}' group to view this page.
                </Text>
            </Box>
        );
    }

    return children;
};

export { RequireGroup };
